var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Medium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(3.55556,3.55556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.049,14c12.011,0 12.951,0.94 12.951,12.951v18.098c0,12.011 -0.94,12.951 -12.951,12.951h-18.098c-12.011,0 -12.951,-0.94 -12.951,-12.951v-18.098c0,-12.011 0.94,-12.951 12.951,-12.951zM29.713,44.151c4.502,0 8.151,-3.649 8.151,-8.151c0,-4.502 -3.649,-8.151 -8.151,-8.151c-4.502,0 -8.151,3.649 -8.151,8.151c0,4.502 3.65,8.151 8.151,8.151zM42.713,43.757c2.228,0 4.034,-3.473 4.034,-7.757c0,-4.284 -1.806,-7.757 -4.034,-7.757c-2.228,0 -4.034,3.473 -4.034,7.757c0,4.284 1.806,7.757 4.034,7.757zM48.98,42.928c0.775,0 1.403,-3.102 1.403,-6.928c0,-3.826 -0.628,-6.928 -1.403,-6.928c-0.775,0 -1.403,3.102 -1.403,6.928c0,3.826 0.628,6.928 1.403,6.928z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Medium);
export default __webpack_public_path__ + "static/media/icons8-medium.f1f74fe6df1b3e5b7ccd3f7cb99f28d7.svg";
export { ForwardRef as ReactComponent };